<mat-sidenav-container>

    <div id="fuse-main-content">
     
        <div id="wrapper">
            <!-- NAVBAR: Left -->
            <fuse-navbar-vertical [folded]="fuseSettings.layout.navigationFolded"
            class="left-navbar"
            [ngClass]="fuseSettings.colorClasses.navbar"
            *ngIf="(fuseSettings.layout.navigation === 'left' || fuseSettings.layout.navigation === 'top')">
            </fuse-navbar-vertical>
            <!-- / NAVBAR: Left -->

            <div class="content-wrapper">

                <!-- TOOLBAR: Below -->
                <ng-container *ngIf="fuseSettings.layout.toolbar === 'below'">
                    <fuse-toolbar class="below" [ngClass]="fuseSettings.colorClasses.toolbar"></fuse-toolbar>
                </ng-container>
                <!-- / TOOLBAR: Below -->
                <fuse-content></fuse-content>   
                
                   <!-- FOOTER: Below -->
                   <ng-container *ngIf="fuseSettings.layout.footer === 'below'">
                        <fuse-footer class="below" [ngClass]="fuseSettings.colorClasses.footer"  style="height: 35px !important;"></fuse-footer>
                    </ng-container>
                    <!-- / FOOTER: Below -->
            </div>

          

        </div>

    </div>

   

</mat-sidenav-container>



// WEBPACK FOOTER //
// D:/Keval/Project/Mindport/HRS/hantraco-app/src/app/main/main.component.html